// extracted by mini-css-extract-plugin
var _1 = "VlBEJ4VzmSM_7kh8QnV3";
var _2 = "wuGPecFb3riRtQafNtOq";
var _3 = "zVUR56Q9rcxdQ_WF6aZU";
var _4 = "I3Fr1pqB6J3tgViRNXG2";
var _5 = "nL0pWp2jr67zpzbuQSEy";
var _6 = "z56KhgGwwUOchFxQcGyj";
var _7 = "cnLfv1EroFPYRooKGdeY";
export { _1 as "colAbbreviation", _2 as "colAction", _3 as "colDerivedFrom", _4 as "colMethodDescription", _5 as "colName", _6 as "colUseToDefaultComponents", _7 as "responsesTable" }
